import React from 'react';
import './aboutus.css';
import { Link } from "react-router-dom";

function AboutUs() {
  const servicesData = [
    {
      id: "prosthetic",
      title: "Prosthetic Solutions",
      description: "Custom-designed artificial limbs for upper and lower extremities using advanced materials and technology."
    },
    {
      id: "orthotic",
      title: "Orthotic Care",
      description: "Personalized orthotic devices to support, align, and improve the function of movable parts of the body."
    },
    {
      id: "rehab",
      title: "Orthopedic Rehabilitation",
      description: "Comprehensive therapy programs designed to restore mobility and strength after injury or surgery."
    },
    {
      id: "pediatric",
      title: "Pediatric Care",
      description: "Specialized rehabilitation services for children with congenital conditions or developmental needs."
    }
  ];

  const achievementsData = [
    { id: "years", number: "15+", label: "Years of Excellence" },
    { id: "patients", number: "3500+", label: "Lives Transformed" },
    { id: "devices", number: "5,000+", label: "Custom Devices Fitted" },
    { id: "satisfaction", number: "100%", label: "Patient Satisfaction" }
  ];

  // const teamData = [
  //   {
  //     id: "doctor1",
  //     name: "Dr. Priyanka Fernando",
  //     position: "Chief Prosthetist & Orthotist",
  //     qualification: "Ph.D. in Prosthetics & Orthotics",
  //     experience: "18+ Years Experience",
  //     image: "/team/doctor1.jpg",
  //     bio: "Leading expert in advanced prosthetic solutions with international training from Germany and Japan."
  //   },
  //   {
  //     id: "doctor2",
  //     name: "Dr. Sanjeewa Perera",
  //     position: "Orthopedic Rehabilitation Specialist",
  //     qualification: "MBBS, MD (Physical Medicine)",
  //     experience: "15+ Years Experience",
  //     image: "/team/doctor2.jpg",
  //     bio: "Pioneer in comprehensive rehabilitation programs, specializing in post-traumatic recovery."
  //   },
  //   {
  //     id: "therapist1",
  //     name: "Mrs. Kumari Weerasinghe",
  //     position: "Senior Orthotist",
  //     qualification: "MSc in Clinical Orthotics",
  //     experience: "12+ Years Experience",
  //     image: "/team/therapist1.jpg",
  //     bio: "Expert in pediatric orthotics and custom spinal bracing solutions."
  //   },
  //   {
  //     id: "therapist2",
  //     name: "Mr. Nuwan Silva",
  //     position: "Rehabilitation Therapist",
  //     qualification: "BSc in Physiotherapy",
  //     experience: "10+ Years Experience",
  //     image: "/team/therapist2.jpg",
  //     bio: "Specializes in gait training and post-prosthetic fitting rehabilitation."
  //   }
  // ];

  const partnersData = [
    
    { id: "SPED", name: "Southern Provincial Ministry of Education", logo: "/sped.png" },
    { id: "NSPD", name: "National Secretariat For Persons With Disabilities", logo: "/NSPD-Logo.png" }
  ];

  const contactData = [
    { id: "phone", text: "+94 77 743 9610" },
    { id: "email", text: "info@southernrehabcare.lk" },
    { id: "address", text: "Hirimbura Rd, Karapitiya, Sri Lanka" }
  ];

  return (
    <div className="southern-rehab-about">





      {/* Hero Section */}
      <section 
        className="rehab-hero-section" 
        style={{ 
          backgroundImage: `linear-gradient(rgba(26, 43, 76, 0.85), rgba(26, 43, 76, 0.85)), url('/banner1.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="rehab-hero-container">
          <div className="rehab-hero-content">
            <span className="rehab-hero-badge">Welcome to Southern Rehab Care</span>
            <h1 className="rehab-hero-title">
              Restoring Mobility, <span className="rehab-hero-highlight">Transforming Lives</span>
            </h1>
            <p className="rehab-hero-subtitle">
              Sri Lanka's premier rehabilitation center in Karapitiya, dedicated to providing 
              advanced prosthetic, orthotic, and orthopedic rehabilitation solutions with 
              compassionate professional care.
            </p>
            <div className="rehab-hero-stats">
              {achievementsData.slice(0, 3).map((stat) => (
                <div key={stat.id} className="rehab-hero-stat-item">
                  <span className="rehab-hero-stat-number">{stat.number}</span>
                  <span className="rehab-hero-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>







      {/* Introduction Section */}
      <section className="rehab-intro-section">
        <div className="rehab-container">
          <div className="rehab-intro-grid">
            <div className="rehab-intro-text-content">
              <span className="rehab-section-badge">Who We Are</span>
              <h2 className="rehab-intro-heading">Leading Rehabilitation Care in Southern Sri Lanka</h2>
              <p className="rehab-intro-paragraph">
                Southern Rehab Centre is a leading rehabilitation clinic specializing in high-quality prosthetics, orthotics, 
                and physical recovery. Serving the South since 2015, we have been dedicated to providing expert prosthetic 
                and orthotic care from the very beginning. <br />

                Our mission is to empower our community through innovative mobility solutions and expert clinical care. 
                From initial assessment to final fitting and physical training, we are your trusted partners in progress.

              </p>
              <p className="rehab-intro-paragraph">
                 We are proud of our history and even more excited about shaping the future of your mobility.
              </p>
              <div className="rehab-intro-features">
                <div className="rehab-intro-feature-item">
                  <span className="rehab-intro-feature-dot"></span>
                  <span>Modern Facility</span>
                </div>
                <div className="rehab-intro-feature-item">
                  <span className="rehab-intro-feature-dot"></span>
                  <span>Expert Team</span>
                </div>
                <div className="rehab-intro-feature-item">
                  <span className="rehab-intro-feature-dot"></span>
                  <span>Certified Care</span>
                </div>
              </div>
            </div>
            <div className="rehab-intro-image-wrapper">
              <img src="/rehab-logo.png" alt="Southern Rehab Care Facility" className="rehab-intro-image" />
              <div className="rehab-intro-experience-badge">
                <span className="rehab-intro-experience-years">15+</span>
                <span className="rehab-intro-experience-text">Years of Excellence</span>
              </div>
            </div>
          </div>
        </div>
      </section>





      <section className="world-brand-section">
  <div className="world-brand-container">

    <div className="world-brand-text">
      <h2>Trusted Partnership with Global Leader Ottobock</h2>

      <p>
We are the official partner for the Southern Province of Ottobock, a world-leading manufacturer of 
advanced prosthetic and orthotic solutions, ensuring our patients receive internationally recognized quality 
and innovation.

      </p>

    </div>

    <div className="ottobock-image">
      <img src="/ottobock.png" alt="Rehabilitation Care" />
    </div>

  </div>
</section>







      {/* Mission & Vision Section */}
      <section className="rehab-mission-section">
        <div className="rehab-container">
          <div className="rehab-mission-grid">
            <div className="rehab-mission-card rehab-mission-primary">
              <h3 className="rehab-mission-title">Our Mission</h3>
              <p className="rehab-mission-text">
                To provide comprehensive, compassionate, and cutting-edge rehabilitation services 
                that empower individuals to achieve optimal mobility and independence, improving 
                their quality of life through personalized care and advanced technology.
              </p>
            </div>
            <div className="rehab-mission-card rehab-mission-secondary">
              <h3 className="rehab-mission-title">Our Vision</h3>
              <p className="rehab-mission-text">
                To be Sri Lanka's most trusted rehabilitation center, recognized for excellence 
                in prosthetic and orthotic care, setting new standards in patient-centered 
                rehabilitation and community wellness.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="rehab-services-section">
        <div className="rehab-container">
          <div className="rehab-section-header">
            <span className="rehab-section-badge">What We Offer</span>
            <h2 className="rehab-section-heading">Comprehensive Rehabilitation Services</h2>
            <p className="rehab-section-subheading">Tailored solutions for every patient's unique needs</p>
          </div>
          <div className="rehab-services-grid">
            {servicesData.map((service) => (
              <div key={service.id} className="rehab-service-card">
                <h3 className="rehab-service-title">{service.title}</h3>
                <p className="rehab-service-description">{service.description}</p>
                {/* <Link to="/services" className="rehab-service-link">
                  Learn More <span className="rehab-service-arrow">→</span>
                </Link> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="rehab-achievements-section">
        <div className="rehab-container">
          <div className="rehab-achievements-grid">
            {achievementsData.map((achievement) => (
              <div key={achievement.id} className="rehab-achievement-card">
                <span className="rehab-achievement-number">{achievement.number}</span>
                <span className="rehab-achievement-label">{achievement.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="rehab-team-section">
        <div className="rehab-container">
          <div className="rehab-section-header">
            <span className="rehab-section-badge">Our Experts</span>
            <h2 className="rehab-section-heading">Meet Our Specialists</h2>
            <p className="rehab-section-subheading">Dedicated professionals committed to your recovery</p>
          </div>
          <div className="rehab-team-grid">
            {teamData.map((member) => (
              <div key={member.id} className="rehab-team-card">
                <div className="rehab-team-image-wrapper">
                  <img src={member.image} alt={member.name} className="rehab-team-image" />
                  <div className="rehab-team-overlay">
                    <span className="rehab-team-experience">{member.experience}</span>
                  </div>
                </div>
                <div className="rehab-team-info">
                  <h3 className="rehab-team-name">{member.name}</h3>
                  <p className="rehab-team-position">{member.position}</p>
                  <p className="rehab-team-qualification">{member.qualification}</p>
                  <p className="rehab-team-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}



      {/* Partners Section */}
      <section className="rehab-partners-section">
        <div className="rehab-container">
          <div className="rehab-section-header">
            <span className="rehab-section-badge">Our Partners</span>
            <h2 className="rehab-section-heading">Trusted By Leading Institutions</h2>
          </div>
          <div className="rehab-partners-grid">
            {partnersData.map((partner) => (
              <div key={partner.id} className="rehab-partner-card">
                <img src={partner.logo} alt={partner.name} className="rehab-partner-logo" />
                <p className="rehab-partner-name">{partner.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="rehab-testimonial-section">
        <div className="rehab-container">
          <div className="rehab-testimonial-content">
            <span className="rehab-testimonial-badge">Patient Story</span>
            <h2 className="rehab-testimonial-heading">What Our Patients Say</h2>
            <div className="rehab-testimonial-card">
              <p className="rehab-testimonial-text">
                "After my accident, I thought I'd never walk normally again. The team at 
                Southern Rehab Care not only provided me with a perfect prosthetic but 
                also gave me the confidence and support to rebuild my life. I'm forever grateful."
              </p>
              <div className="rehab-testimonial-author">
                <img src="/kamal.jpg" alt="Patient Kamal Perera" className="rehab-testimonial-author-image" />
                <div className="rehab-testimonial-author-info">
                  <h4 className="rehab-testimonial-author-name">Kamal Perera</h4>
                  <p className="rehab-testimonial-author-since">Patient since 2018</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="rehab-contact-section">
        <div className="rehab-container">
          <div className="rehab-contact-grid">
            {contactData.map((item) => (
              <div key={item.id} className="rehab-contact-item">
                <span className="rehab-contact-text">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="rehab-cta-section">
        <div className="rehab-container">
          <div className="rehab-cta-content">
            <h2 className="rehab-cta-heading">Begin Your Journey to Recovery</h2>
            <p className="rehab-cta-subheading">Take the first step towards better mobility and independence</p>
            <div className="rehab-cta-buttons">
              <Link to="/contactus" className="rehab-btn rehab-btn-primary">
                Schedule Consultation
              </Link>
              <Link to="/upper-extremity-prosthetics" className="rehab-btn rehab-btn-secondary">
                Explore Products
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;